export const arrayContainArray = (arr1: any[], arr2: any[]) => {
  return !arr2.length ? false : arr2.reduce((prev: boolean, currentValue) => {
    return !prev ? prev : arr1.includes(currentValue);
  }, true);
}
